import type { ConstructionFormState, LayeredConstructionCatalogItem, LayeredConstructionSavePayload } from "../model/types";
import type { LayeredConstructionVariant } from "../model/variants";

import { findCatalogItem } from "./configOptions";
import { serializeLayers } from "./layers";

type BuildConstructionSavePayloadOptions = {
  catalog: LayeredConstructionCatalogItem[];
  formState: ConstructionFormState;
  variant: LayeredConstructionVariant;
};

export const buildConstructionSavePayload = ({
  catalog,
  formState,
  variant,
}: BuildConstructionSavePayloadOptions): LayeredConstructionSavePayload => {
  const serialized = serializeLayers(formState.layers);
  const linkedItem = findCatalogItem(catalog, formState.typeName);

  if (linkedItem) {
    return {
      ...serialized,
      color: formState.color || undefined,
      manuallyOverridden: false,
      [variant.typeDbIdKey]: linkedItem.id,
    };
  }

  return {
    ...serialized,
    color: formState.color || undefined,
    manuallyOverridden: true,
    [variant.typeDbOverrideKey]: {
      ...serialized,
      [variant.catalogTypeNameKey]: formState.typeName,
    },
  };
};
